import type { ManualGuideKey } from "../Manual/manualGuides";

/**
 * 업데이트 소식 원본 데이터(releases). 제목·설명 문구는 `landing:site.releases.items.<key>` 에 4개 언어로 있고,
 * 추상 그림은 사이트 미디어 `release-art/<key>.svg` 다. 새 소식은 맨 앞에 더한다 — 최신순이 아니면 테스트가 실패한다.
 * `demo` 는 「시연 영상 보기」로 가는 매뉴얼 절 — 그 절 안내 그림에 이 기능이 실제로 나올 때만 둔다(장으로 잇거나 비슷한 절로 대신하지 않는다).
 */
export const RELEASE_ITEMS = [
  { date: "2026-10-20", key: "auto_mapping", demo: "t-mapping", demoStep: 2 },
  { date: "2026-10-15", key: "equip_sim", demo: "t-route" },
  { date: "2026-10-14", key: "linear_ew", demo: "t-linear" },
  { date: "2026-09-30", key: "ew_summary", demo: "t-ewzone" },
  { date: "2026-09-30", key: "folders", demo: "t-folder" },
  { date: "2026-08-27", key: "walk_roadview" },
  { date: "2026-08-12", key: "history", demo: "t-history" },
  { date: "2026-07-31", key: "area_capture", demo: "t-capture", demoStep: 5 },
  { date: "2026-07-22", key: "issue_comments", demo: "t-issueinfo", demoStep: 8 },
  { date: "2026-07-16", key: "pano360" },
  { date: "2026-07-14", key: "clip_box", demo: "t-clip" },
  { date: "2026-07-14", key: "dsm_color", demo: "t-3dlayer", demoStep: 2 },
  { date: "2026-07-14", key: "vectors", demo: "t-vector", demoStep: 2 },
  { date: "2026-07-13", key: "workers", demo: "t-members" },
  { date: "2026-07-02", key: "first_person", demo: "t-fly" },
  { date: "2026-06-30", key: "geolog_map", demo: "t-geolog", demoStep: 4 },
  { date: "2026-06-08", key: "ja", demo: "t-lang" },
  { date: "2026-06-08", key: "dxf_on_3d", demo: "t-3dlayer", demoStep: 9 },
  { date: "2026-06-08", key: "profile_3d", demo: "t-pf-dxf3d" },
] as const satisfies readonly ReleaseItem[];

export interface ReleaseItem {
  /** `YYYY-MM-DD` */
  date: string;
  key: string;
  /** 시연 영상(단계별 안내)이 있는 매뉴얼 절 id — 안내 키와 같다 */
  demo?: ManualGuideKey;
  /** 그 절 안내에서 이 기능이 처음 나오는 단계(1부터) — 절 처음부터가 아닐 때만. 「시연 영상 보기」가 이 단계부터 연다 */
  demoStep?: number;
}

/** 소식을 달별로 묶는다(최신 달부터). 키는 `YYYY-MM`. */
export function groupReleasesByMonth<T extends ReleaseItem>(
  items: readonly T[]
): Array<{ month: string; items: T[] }> {
  const groups = new Map<string, T[]>();
  for (const item of items) {
    const month = item.date.slice(0, 7);
    groups.set(month, [...(groups.get(month) ?? []), item]);
  }
  return [...groups].map(([month, monthItems]) => ({
    month,
    items: monthItems,
  }));
}
